import { useMutation } from "@apollo/client";

import type {
  UpdateDeviceInput,
  UpdateDeviceMutation,
  UpdateDeviceMutationVariables,
} from "../../../API";
import { UPDATE_DEVICE } from "../../../common/operations/mutations";
import { handleApolloError } from "../../../common/utils/handleApolloError";

export const useUpdateDevice = () => {
  const [putDevice, { data, loading }] = useMutation<
    UpdateDeviceMutation,
    UpdateDeviceMutationVariables
  >(UPDATE_DEVICE);

  const updateDevice = async (input: UpdateDeviceInput) => {
    return await putDevice({
      variables: {
        input,
      },
      onError: handleApolloError,
    });
  };

  return { updateDevice, data, loading };
};
